import { ModalBody } from "@chakra-ui/react";
import CollegeAdvisorForm from "@/components/collegeadvisor/CollegeAdvisorForm";
import { ScrollBackUpTriggeredModal } from "@/components/shared/ScrollTriggeredModal";
import { useUserData } from "@/contexts/UserDataContext";

export default function CollegeAdvisorModal() {
  return null;
}

function CollegeAdvisorModalOld() {
  const userDataContext = useUserData();
  const userDataCollegeAdvisor = userDataContext?.userData?.collegeAdvisor;
  if (userDataCollegeAdvisor) {
    return null;
  }
  return (
    <ScrollBackUpTriggeredModal scrollPos={{ base: 700, md: 1000 }} delay={1000}>
      <ModalBody>
        <CollegeAdvisorForm context={"modal"} />
      </ModalBody>
    </ScrollBackUpTriggeredModal>
  );
}
